// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__Q1fic","title":"index_title__1Qyrm","desc":"index_desc__RQ6_9"};